export default "__VITE_ASSET__B9hyF6V7__"